module.exports = __webpack_public_path__ + "3dd67ecba54b1293d18ce657119ed3e2.png";